import {
  Finding,
  FindingsByOrgan,
  KeyImage,
  KeyImageLabel,
  RadiologistStudyKeyImagesResponse,
} from '@/api';

export function getKeyImagesFromFindings(findings: FindingsByOrgan) {
  const findingsFlat: Finding[] = Object.keys(findings)
    .map((key) => findings[key])
    .flat();

  const keyImagesInsideFindings: KeyImageLabel[] = findingsFlat
    .filter((finding) => finding.renderedSummary.keyImages.length > 0)
    .map((finding) => finding.renderedSummary.keyImages)
    .flat()
    .filter((keyImage) => keyImage.status !== 'deprecated');

  return keyImagesInsideFindings;
}

export function getNonDeprecatedKeyImageLabels(labels: KeyImageLabel[]) {
  return labels.filter((label) => label.status !== 'deprecated');
}

/**
 * Maps the radiologist study key images response to an array of `KeyImage` objects.
 *
 * @param data - The response object containing key images and associated data.
 * @returns An array of `KeyImage` objects, each containing the image ID, image data,
 *          instance number, and processed S3 key.
 */
export function getMappedKeyImages(data: RadiologistStudyKeyImagesResponse): KeyImage[] {
  return data.key_images.instanceNumbers.map((instanceNumber) => ({
    id: data.key_images.imageKeys[instanceNumber],
    image: data.images[instanceNumber],
    instanceNumber,
    processedS3Key: data.key_images.processed[instanceNumber],
  }));
}
